<template>
  <div class="chart-block">
    <h3>     <a :href="url" target="_blank"> {{chartName}}</a>
        <el-tooltip class="item" effect="dark" content="新四化指数" placement="bottom">
        <svg-icon name="faq" size="20" @click.native="faq()" color="#53b1e7"></svg-icon>
      </el-tooltip>
             <span>{{updated}}</span>
       </h3>
    <div id="chart_csxs" class="chart-box"></div>
  </div>
</template>
<script>
import echarts from "echarts";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import {formatDate,strToFormatDate,strToYeayAndMonth} from "@/plugins/DateTimeFormater.js";
export default {
  props: {
    chartName: { type: String, default: "历年车身形式销量变化" }
  },
  data() {
    return {
      url:"#",
      chartOption: {},
      myChart:null,
      chartId:'body_changes_history',
            updated:'',
    };
  },
  mounted() {
 

    this.chartOption = {
     // color: ["#4ebdea", "#a7def3", "#327ed4", "#5aa0b3"],
      // color: ["#60acfc", "#32d3eb", "#5bc49f", "#feb64d", "#ff7c7c", "#9287e7"],
       color: ['#5f96e6','#57b6e6','#55ca95','#7e92c7' ],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        }
      },
      legend: {
        data: []//["HB", "MPV", "NB", "SUV", "WAGON"]
      },
      toolbox: {
        show: true,
        right: "50",
        top: "-5",
        feature: {
          mark: { show: true },
          magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
          restore: { show: true }
        }
      },
      xAxis: [
        {
          type: "category",
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: "#3b5b81" },
          data: []//["2016", "2017", "2018", "2019"]
        }
      ],
      yAxis: [
        {
          type: "value",
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: "#3b5b81",	textStyle: {
				color: '#1B253A',
				fontStyle: 'normal',
				fontFamily: '微软雅黑',
				fontSize: 12,
			}, },
          
          splitLine: { show: true, lineStyle: { type: "solid" } },
          splitNumber: 4
        }
      ],
      series: [
      
      ]
    };

  this.getChartList({handle:this.updateChart});
    
  },
  methods: {

    ...mapActions("home", ["queryChartConfigs", "queryChartUpdate","getChartList"]),
    updateChart() {
      this.myChart = echarts.init(document.getElementById("chart_csxs"));
      var info = this.getChartByName(this.chartId);
      this.url = info.url;
        var json= eval(info.jsonData);
        var years = [...new Set(json.map(x=>x.year))];
        var bodys = [...new Set(json.map(x=>x.body))];

       this.chartOption.xAxis[0].data = years;
       this.chartOption.legend.data = bodys;
       for(var body of bodys)
       {
          var rs=  json.filter(x=>x.body==body);
          var counts =  [...new Set(rs.map(x=>x.count))];
          
          var serie = { type: "bar", name:body, data:counts};
          this.chartOption.series.push(serie);
      
       }
       
      this.myChart.setOption(this.chartOption);
      window.addEventListener("resize", function() {
         this.myChart && this.myChart.resize();
      });
         
      this.updated = `${strToYeayAndMonth(info.lastUpdated)}更新`;
        
       
    }
  },
  watch: {},
  created() {},
   computed: {
    ...mapGetters("home", {chartList: "chartList",getChartByName: "getChartByName"}),
  }
};
</script>
<style scoped>
#chart_csxs {
  min-height: 250px;
  width: 100%;
  margin-left: 20px;
}
</style>
 